module.exports = "<h1 class=\"bluetext\" style=\"text-align: center\">401 - Unauthorized Error</h1>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/users/unauthorized.component.html
// module id = ./src/app/users/unauthorized.component.html
// module chunks = main